import { DAIMI_TC_INTRO, DAIMI_TC_SLUG } from '@/content/daimiTechnology'
import { focus } from '@/content/reportBuilder'
import type { Report } from '@/content/reportBuilder'

export const report: Report = {
  // The twenty-third report with a designed page of its own, and the eighth focus
  // cut to arrive with both of its figures — asked for on 2026-08-28 in the same
  // words as the Tourism cut hours before it (*"referans alarak ilgili sayfayı
  // birebir tıpa tıp aynısını tasarla"*) with a four-part full-page capture of the
  // live page, the cover as two overlapping 2000px crops, Figure 1 and the report
  // mockup. See `content/daimiTechnology.ts` and `pages/DaimiTechnology.tsx`.
  ...focus(
    DAIMI_TC_SLUG,
    'Technology',
    'daimi-report-2026-technology-cover',
    '09a243b3-34db-4692-bd46-874eccb508fb-digitopia-daimi-2026-report-technology.pdf',
  ),
  // The sector's own paragraphs, transcribed from the reference capture and held
  // on the page that says them — so the search result and the page cannot drift
  // apart. `prerender.tsx` takes the meta description from `body[0]`.
  body: DAIMI_TC_INTRO.body,
  layout: 'technology-focus',
  // Its own words, its cover, its file and both of its figures, so `stillToCome`
  // has nothing left to say about it. What is still open is section-by-section on
  // its page, and `daimiTechnologyChecks()` carries that into the manifest.
  check: undefined,
}

/** Its place in the index grid — the order the imported page listed them. */
export const order = 17
